import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { Row, Col, Card, CardBody, Input, Table } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import AreaChart from "../AllCharts/apex/areachart"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import DonutChart from "./DonutChart"
import BarApexChart from "./barchart"
import CommonApi from "Api/CommonApi"
import Country from "utils/Data/Country"
import TaskApi from "Api/TaskApi"
import { Dropdown } from "primereact/dropdown"
import { set } from "lodash"
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts"

const Dashboard = props => {
  document.title = "Dashboard | Pixwik - Admin"
  const accessToken = localStorage.getItem("accessToken")

  const breadcrumbItems = [
    { title: "Pixwik", link: "#" },
    { title: "Dashboard", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Dashboard", breadcrumbItems)
  })
  const userData = JSON.parse(localStorage.getItem("userData"))

  const [metadata, setMetaData] = useState({})
  const [todayData, setTodayData] = useState({})
  const [todayInstitutionData, setTodayInstitutionData] = useState({})
  const [institutionDataLoaded, setInstitutionDataLoaded] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [selectedCountry, setSelectedCountry] = useState({
    name: "India",
    code: "India",
  })
  const [countryData, setCountryData] = useState({})
  const [countryLoaded, setCountryLoaded] = useState(false)
  const [taskDetails, setTaskDetails] = useState([])
  const [taskLoaded, setTaskLoaded] = useState(false)
  const [taskDetailsUser, setTaskDetailsUser] = useState([])
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"]

  const getAllMetaData = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    CommonApi.getAllMetaData(config)
      .then(response => {
        setMetaData(response.data)
        setTodayData(response.data.today)
        setTodayInstitutionData(response.data.todayInstitutions)
        setDataLoaded(true)
        setInstitutionDataLoaded(true)
      })
      .catch(error => {
        setDataLoaded(false)
        setInstitutionDataLoaded(false)
      })
  }

  const getCountryEducationList = country => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    CommonApi.getCountryEducationStats(country, config)
      .then(response => {
        setCountryData(response.data.data)
        setCountryLoaded(true)
      })
      .catch(error => {
        setCountryLoaded(false)
      })
  }

  const TrackAllUserDailyOperations = data => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    TaskApi.trackAllUserDailyOperations(data, config)
      .then(response => {
        setTaskDetails(response.data.data)
        setTaskLoaded(true)
      })
      .catch(error => {
        setTaskLoaded(false)
      })
  }

  const TrackUserDailyOperations = data => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    TaskApi.trackUserDailyOperations(data, config)
      .then(response => {
        setTaskDetailsUser(response.data.data)
        setTaskLoaded(true)
      })
      .catch(error => {
        setTaskLoaded(false)
      })
  }
  useEffect(() => {
    getAllMetaData()
    getCountryEducationList("India")
    TrackAllUserDailyOperations()
    TrackUserDailyOperations(userData._id)
  }, [accessToken])

  const reports = [
    {
      title: "Universities",
      iconClass: "ion ion-ios-school",
    },
    {
      title: "Institutions",
      iconClass: "ion ion-md-business",
    },
    {
      title: "Programs",
      iconClass: "ion ion-md-list-box",
    },
    {
      title: "Courses",
      iconClass: "ion ion-md-bookmarks",
    },
  ]

  const updatedReports = reports.map(report => ({
    ...report,
    total: metadata[report.title.toLowerCase()] || 0, // Use default 0 if not found
  }))

  return (
    <React.Fragment>
      <Miniwidget reports={updatedReports} />

      <Row>
        <Col lg="6" style={{ height: "480px" }}>
          <Card style={{ height: "100%" }}>
            <CardBody>
              <h4 className="card-title mb-4">Today's activity</h4>

              <Row className="text-center mt-4">
                <Col sm="3">
                  <h5 className="mb-0 font-size-20">
                    {todayData.universities}
                  </h5>
                  <p className="text-muted">Universities</p>
                </Col>
                <Col sm="3">
                  <h5 className="mb-0 font-size-20">
                    {todayData.institutions}
                  </h5>
                  <p className="text-muted">Institutions</p>
                </Col>
                <Col sm="3">
                  <h5 className="mb-0 font-size-20">{todayData.programs}</h5>
                  <p className="text-muted">Programs</p>
                </Col>
                <Col sm="3">
                  <h5 className="mb-0 font-size-20">{todayData.courses}</h5>
                  <p className="text-muted">Courses</p>
                </Col>
              </Row>

              <div dir="ltr">
                {dataLoaded && <DonutChart data={todayData} type="activity" />}
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg="6" style={{ height: "480px" }}>
          <Card style={{ height: "100%" }}>
            <CardBody>
                <h4 className="card-title mb-4">Today's Institution Data</h4>
              <Row className="text-center mt-4">
                <Col sm="2">
                  <h5 className="mb-0 font-size-20">
                    {todayInstitutionData.medical}
                  </h5>
                  <p className="text-muted font-size-12">Medical</p>
                </Col>
                <Col sm="2">
                  <h5 className="mb-0 font-size-20">
                    {todayInstitutionData.engineering}
                  </h5>
                  <p className="text-muted font-size-12">Engineering</p>
                </Col>
                <Col sm="2">
                  <h5 className="mb-0 font-size-20">{todayInstitutionData.law}</h5>
                  <p className="text-muted font-size-12 ">Law</p>
                </Col>
                <Col sm="2">
                  <h5 className="mb-0 font-size-20">{todayInstitutionData.arts}</h5>
                  <p className="text-muted font-size-12">Arts</p>
                </Col>
                  <Col sm="2">
                    <h5 className="mb-0 font-size-20">{todayInstitutionData.agriculture}</h5>
                    <p className="text-muted font-size-12">Agriculture</p>
                </Col>
                <Col sm="2">
                  <h5 className="mb-0 font-size-20">{todayInstitutionData.management}</h5>
                  <p className="text-muted font-size-12">Management</p>
                </Col>
              </Row>
              <div dir="ltr"  >
                {institutionDataLoaded && <DonutChart data={todayInstitutionData} type="institution" />}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <>
          {userData.role === "data analyst" && (
            <Row>
              <Col lg="12" style={{ height: "440px" }}>
                <Card style={{ height: "100%" }}>
                  <CardBody className="d-flex align-items-center  gap-2 justify-content-center">
                    <h4 className="card-title mb-4">My Task Data</h4>

                    <div className="d-flex justify-content-center">
                      {taskDetailsUser ? (
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart
                            data={[
                              {
                                name: "Universities",
                                value: taskDetailsUser.universityCount || 0,
                              },
                              {
                                name: "Institutions",
                                value: taskDetailsUser.institutionCount || 0,
                              },
                              {
                                name: "Programs",
                                value: taskDetailsUser.programCount || 0,
                              },
                              {
                                name: "Courses",
                                value: taskDetailsUser.courseCount || 0,
                              },
                            ]}
                            layout="vertical"
                            margin={{ top: 5, right: 20, left: 20, bottom: 5 }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" />
                            <YAxis dataKey="name" type="category" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="value" fill="#8884d8" barSize={30} />
                          </BarChart>
                        </ResponsiveContainer>
                      ) : (
                        <p className="text-center">No data available</p>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {userData.role === "manager" && (
            <Col lg="12" style={{ height: "440px" }}>
              <Card style={{ height: "100%" }}>
                <CardBody>
                  <h4 className="card-title mb-4">Today's Task Data</h4>

                  <div className="table-responsive   overflow-auto">
                    <Table className="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Analyst Name</th>
                          <th>Universities</th>
                          <th>Institutions</th>
                          <th>Programs</th>
                          <th>Courses</th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetails && taskDetails.length > 0 ? (
                          taskDetails.map((task, index) => (
                            <tr key={task.userId || index}>
                              <td>{index + 1}</td>
                              <td>{task.name || "N/A"}</td>
                              <td>{task.universityCount || 0}</td>
                              <td>{task.institutionCount || 0}</td>
                              <td>{task.programCount || 0}</td>
                              <td>{task.courseCount || 0}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
        </>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <Card>
            <CardBody>
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="card-title">Institution Data</h4>
                <Dropdown
                  id="country"
                  value={selectedCountry}
                  onChange={e => {
                    setSelectedCountry(e.value)
                    getCountryEducationList(e.value.name)
                  }}
                  options={Country}
                  optionLabel="name"
                  placeholder="Select Country"
                  filter
                  className="inp-field-box"
                />
              </div>

              <div dir="ltr">
                {countryLoaded && <BarApexChart data={countryData} />}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
